import { render } from "@testing-library/react";
import React from "react";
import Navigation from "./components/Navigation"

function App() {
    
    return (
      <React.Fragment>
        <div className="App">
          <Navigation />
        </div>
      </React.Fragment>
    );
  

}

export default App;
